import { matchPath, useLocation } from 'react-router';

import type { Project } from 'src/shared/graphql/generated';
import { useGetProjectsQuery } from 'src/shared/graphql/generated';
import { useIsEmbed } from 'src/shared/hooks';
import { Route } from 'src/shared/route';

export const useReferringProject = () => {
  const isEmbed = useIsEmbed();
  const { data, loading } = useGetProjectsQuery({
    fetchPolicy: 'cache-and-network',
    skip: isEmbed,
  });

  const location = useLocation<{ referrer?: string }>();
  const referrer = location.state?.referrer ?? '';
  const match = matchPath<{ projectId: string }>(
    referrer || location.pathname,
    [
      Route.HOMEOWNER_APP_PROJECT_DISPLAY_FULLSCREEN.path,
      Route.HOMEOWNER_APP_PROJECT.path,
    ],
  );
  const { projectId } = match?.params ?? {};
  const projects = data?.projects ?? [];
  const referreringProject = projects.find(p => p.id === Number(projectId)) as
    | Project
    | undefined;

  return { projects, referreringProject, loading };
};
